import { create } from 'zustand';
import { getComponentStore } from '../../utils/componentStoreRegistry';

const createFormBuilderStore = () => create((set, get) => ({
  loaded: false,
  save: null,
  registerSave: (fn) => set({ save: fn }),
  unregisterSave: () => set({ save: null }),
}));

export function getFormBuilderStore(componentId) {
  return getComponentStore('form-builder', componentId, createFormBuilderStore);
}
